/*
bigbang.hr - produkcija
sdhr.bigbangmarkerdev.info - dev
beta.bigbang.hr - dev s produkcijskim podacima
*/

export const config = {
	default: 'prod',
	sdhr: {
		host: 'https://sdhr.bigbangmarkerdev.info',
		lang: 'hr',
		apiCache: false,
		routeCacheExpire: 0, // 5 min
	},
	beta: {
		host: 'https://beta.bigbang.hr',
		lang: 'hr',
		apiCache: false,
		routeCacheExpire: 0,
	},	
	prod: {
		host: 'https://www.bigbang.hr',
		lang: 'hr',
		apiCache: true,
		routeCacheExpire: 305, // 5 min
	},
	mp: {
		host: 'https://mp.bigbangmarkerdev.info',
		lang: 'si',
		apiCache: false,
		routeCacheExpire: 0, // 5 min
	},	
};